import cubeActive from '@assets/cube-active.png';
import cube from '@assets/cube.png';
import measureActive from '@assets/measure-active.png';
import measure from '@assets/measure.png';
import perspectiveActive from '@assets/perspective-new-active.png';
import perspective from '@assets/perspective-new.png';
import refresh from '@assets/refresh.png';
import { IconButton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  setMeasurementColorModalState, setMeasurementLines, setMeasuringState, setPerspective, setRefresh
} from '@store/reducers/viewerSlice';
import { memo, useCallback } from 'react';
import { PaletteIcon, TrashIcon } from 'react-line-awesome';
import { NavHelper, NavHelperImage, NavHelperItem, SubMenuMeasurement } from './ActionButtons.styled';

const ActionButtons = memo(() => {
  const { isPerspective, isMeasuring } = useAppSelector(state => state.viewer);
  const dispatch = useAppDispatch();

  const toggleMeasuring = useCallback(() => {
    dispatch(setMeasuringState(!isMeasuring));
  }, [dispatch, isMeasuring]);

  const switchToPerspective = useCallback(() => {
    dispatch(setPerspective(true));
  }, [dispatch]);

  const switchToOrthographic = useCallback(() => {
    dispatch(setPerspective(false));
  }, [dispatch]);

  const refreshView = useCallback(() => {
    dispatch(setRefresh(true));
  }, [dispatch]);

  const clearMeasurements = useCallback(() => {
    dispatch(setMeasurementLines([]));
  }, [dispatch]);

  const openColorModal = useCallback(() => {
    dispatch(setMeasurementColorModalState(true));
  }, [dispatch]);

  return (
    <NavHelper>
      <NavButton
        icon={measure}
        activeIcon={measureActive}
        isActive={isMeasuring}
        onClick={toggleMeasuring}
      />

      {isMeasuring && (
        <SubMenuMeasurement>
          <IconButton onClick={clearMeasurements}>
            <TrashIcon />
          </IconButton>
          <IconButton onClick={openColorModal}>
            <PaletteIcon />
          </IconButton>
        </SubMenuMeasurement>
      )}

      <hr className="my-2" style={{ borderColor: '#aaa', width: '50%' }} />

      <NavButton
        icon={cube}
        activeIcon={cubeActive}
        isActive={isPerspective}
        onClick={switchToPerspective}
      />

      <NavButton
        icon={perspective}
        activeIcon={perspectiveActive}
        isActive={!isPerspective}
        onClick={switchToOrthographic}
      />

      <hr className="my-2" style={{ borderColor: '#aaa', width: '50%' }} />

      <NavButton
        icon={refresh}
        activeIcon={refresh}
        isActive={false}
        onClick={refreshView}
      />
    </NavHelper>
  );
});

export default ActionButtons;

const NavButton = ({ icon, activeIcon, isActive, onClick, style = {} }
  : { icon: string; activeIcon: string; isActive: boolean; onClick: () => void; style?: React.CSSProperties; }) => (
  <NavHelperItem onClick={onClick}>
    <NavHelperImage
      src={isActive ? activeIcon : icon}
      style={!isActive ? { filter: 'brightness(0) invert(1)', ...style } : style}
    />
  </NavHelperItem>
);
